import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "visit-documents-hos-pal" }
const _hoisted_2 = { class: "upload-header py-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "d-inline mr-auto" }, "Attachments", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " Click Add Attachment to upload files associated with this task. Once uploaded, files will appear below ", -1 /* HOISTED */)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "w-100"
}
const _hoisted_8 = { class: "upload-filters" }
const _hoisted_9 = { class: "doc-body" }
const _hoisted_10 = { class: "table table-responsive-md borderless" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "File"),
    /*#__PURE__*/_createElementVNode("th", null, "Document Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Updated"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-8" })
], -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-6" })
], -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-6" })
], -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-4" })
], -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file me-1 fa-lg" }, null, -1 /* HOISTED */)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  colspan: "4"
}
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = ["onClick", "disabled"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "text-default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddAttachmentsFormHosPal = _resolveComponent("AddAttachmentsFormHosPal")!
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.uploadFile && _ctx.addPatientDocumentsPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleUploadFile && _ctx.toggleUploadFile(...args))),
                class: "btn btn-primary border border-primary",
                disabled: _ctx.isPlanner
              }, " Add Attachment ", 8 /* PROPS */, _hoisted_6)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.uploadFile && _ctx.addPatientDocumentsPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_AddAttachmentsFormHosPal, {
              visitDetails: _ctx.visitDetails,
              toggleUploadFile: _ctx.toggleUploadFile,
              onAttachmentsRefresh: _ctx.loadAttchments
            }, null, 8 /* PROPS */, ["visitDetails", "toggleUploadFile", "onAttachmentsRefresh"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "document-filters")
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("table", _hoisted_10, [
        _hoisted_11,
        (_ctx.taskAttchments?.length == 0 && !_ctx.loadingDocuments)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
              _createVNode(_component_TableEmpty, {
                "col-span": 5,
                component: "attachments",
                "secondary-message": "No Attachments to Display"
              })
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
              (_ctx.loadingDocuments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, _hoisted_18))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.loadingDocuments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.taskAttchments, (document) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: document.Id
                    }, [
                      _createElementVNode("td", null, [
                        _hoisted_19,
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.downloadDocuments(document))
                        }, _toDisplayString(document.DocumentName), 9 /* TEXT, PROPS */, _hoisted_20)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(document?.UploadType), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(document.LastUpdated)), 1 /* TEXT */),
                      _createCommentVNode(" DELETE "),
                      (_ctx.documentToDelete === document?.Id)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                            _createVNode(_component_TablePrompt, {
                              "ok-text": "Delete",
                              cancelText: "Cancel",
                              operation: " ",
                              name: "Delete",
                              includeYes: true,
                              isInProgress: _ctx.isDeleteInProgress,
                              ok: _ctx.deleteSelectedDocument,
                              cancel: _ctx.cancelDeleteAttachment
                            }, null, 8 /* PROPS */, ["isInProgress", "ok", "cancel"])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode(" ACTIONS  "),
                            _createElementVNode("td", _hoisted_22, [
                              (_ctx.editPatientDocumentsPermission || _ctx.deletePatientDocumentsPermission)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.deletePatientDocumentsPermission)
                                      ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn table-btn btn-outline-danger",
                                          onClick: ($event: any) => (_ctx.requestDelete(document?.Id)),
                                          disabled: _ctx.isPlanner
                                        }, _hoisted_25, 8 /* PROPS */, _hoisted_23)), [
                                          [_directive_tooltip, { title: 'Delete' }]
                                        ])
                                      : _createCommentVNode("v-if", true),
                                    _withDirectives((_openBlock(), _createElementBlock("button", {
                                      type: "button",
                                      class: "btn table-btn btn-outline-info au-target",
                                      onClick: ($event: any) => (_ctx.openSelectedDocument(document))
                                    }, _hoisted_28, 8 /* PROPS */, _hoisted_26)), [
                                      [_directive_tooltip, { title: 'View' }]
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock("i", _hoisted_29, "No Actions"))
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
      ])
    ])
  ]))
}